export default __webpack_public_path__ + "ca4ad6b794be3d127a289beec4d87c9d.png";